<template>
  <div class="landing-admin" style="overflow-x: hidden">

    <img src="@/assets/newDesign/fish.png" style="max-width:60rem;margin-right:10rem">
    <div class="login-admin" align="right">
      <img src="@/assets/newDesign/logo_color.svg" style="height:6.5rem">
      <div
        style="
          position:absolute;
          top:calc(10rem - 3.5rem);
          right:5rem;
          font-size:1.2rem;
          font-weight:bold
        "
      >ADMIN</div>
      <login>        
      </login>
    </div>
  </div>
</template>

<script>
import Login from "./login";

// import Current from "./current";
export default {
  components: {
    Login,
  },
};
</script>

<style scoped>
.landing-admin {
  background-color: #FEFBF6;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.login-admin{
  border:1px solid #cccccc;
  border-radius:8px;
  background-color: white;
  padding: 2rem 4rem;
  position: relative;
}
</style>
